  <!-- ======= Mobile nav toggle button ======= -->
  <button type="button" class="mobile-nav-toggle d-xl-none"><i class="icofont-navigation-menu"></i></button>

  <!-- ======= Header ======= -->
  <header id="header">
    <div class="d-flex flex-column">

      <div class="profile">
        <img src="assets/img/Archivo_000.jpg" alt="" class="img-fluid rounded-circle">
        <h1 class="text-light"><a href="#hero" class="scrollto">David Raygosa</a></h1>
        <div class="social-links mt-3 text-center">
          <a href="https://www.facebook.com/david.raygosa" class="facebook"><i class="bx bxl-facebook"></i></a>
          <a href="https://instagram.com/david_raygosa?r=nametag" class="instagram"><i class="bx bxl-instagram"></i></a>
          <a href="https://github.com/DavidRaygosa" class="github"><i class="bx bxl-github"></i></a>
        </div>
        <!-- MULTILANGUAGE
        <div class="mx-auto text-center mt-4 col-8">
          <a class="float-left"><h1 class="flag-icon flag-icon-us"></h1></a>
          <a class="float-right"><h1 class="flag-icon flag-icon-mx flag-icon-squared"></h1></a>
        </div>
        -->
      </div>  

      <nav class="nav-menu">
        <ul>
          <li class="active"><a href="#hero"><i class="bx bx-home"></i> <span>Home</span></a></li>
          <li><a href="#about"><i class="bx bx-user"></i> <span>Acerca de</span></a></li>
          <li><a href="#resume"><i class="bx bx-file-blank"></i> <span>Resumen</span></a></li>
          <li><a href="#contact"><i class="bx bx-envelope"></i> Contacto</a></li>

        </ul>
      </nav><!-- .nav-menu -->
      <button type="button" class="mobile-nav-toggle d-xl-none"><i class="icofont-navigation-menu"></i></button>

    </div>
  </header><!-- End Header -->

  <!-- ======= Hero Section ======= -->
  <section id="hero" class="d-flex flex-column justify-content-center align-items-center">
    <div class="hero-container" data-aos="fade-in">
      <h1>David Raygosa</h1>
      <p><span class="typed my-typed" data-typed-items="Desarrollador Front-End, Desarrollador Back-End, Freelancer"></span></p>
    </div>
  </section><!-- End Hero -->

  <main id="main">

    <!-- ======= About Section ======= -->
    <section id="about" class="about">
      <div class="container">

        <div class="section-title">
          <h2>Acerca de</h2>
        </div>

        <div class="row">
          <div class="col-lg-4" data-aos="fade-right">
            <img src="assets/img/Archivo_000.jpg" class="img-fluid rounded" alt="">
          </div>
          <div class="col-lg-8 pt-4 pt-lg-0 content" data-aos="fade-left">
            <h3> Desarrollador UI/UX &amp; Desarrollador Back-end.</h3>
            <div class="row mt-4">
              <div class="col-lg-6">
                <ul>
                  <li><i class="icofont-rounded-right"></i> <strong>Cumpleaños:</strong> 6 Abril 1997</li>
                  <li><i class="icofont-rounded-right"></i><strong>Teléfono:</strong><a href="tel:+525560926093"> +52 55 6092 6093 </a></li>
                  <li><i class="icofont-rounded-right"></i> <strong>Ciudad:</strong> Estado de México, México</li>
                </ul>
              </div>
              <div class="col-lg-6">
                <ul>
                  <li><i class="icofont-rounded-right"></i> <strong>Edad:</strong> 23</li>
                  <li><i class="icofont-rounded-right"></i> <strong>Grado:</strong> Ingeniero</li>
                  <li><i class="icofont-rounded-right"></i> <strong>Email:</strong><a href="mailto:david.raygosa97@gmail.com"> david.raygosa97@gmail.com </a></li>
                  <li><i class="icofont-rounded-right"></i> <strong>Freelance:</strong> Disponible</li>
                </ul>
              </div>
            </div>
            <p>
              Me considero una persona que aprovecha al maximo sus conocimientos y habilidades, para obtener una alta solucion a las necesidades tecnologicas. Trabajando en equipo para desarrollarme personalmente y profesionalmente; de la misma manera aprendiendo y superandome dia a dia.
            </p>
          </div>
        </div>

      </div>
    </section><!-- End About Section -->

    <!-- =======  Facts Section =======

    <section id="facts" class="facts">
      <div class="container">

        <div class="section-title">
          <h2>Facts</h2>
          <p>Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga eum quidem. Sit sint consectetur velit. Quisquam quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea. Quia fugiat sit in iste officiis commodi quidem hic quas.</p>
        </div>

        <div class="row no-gutters">

          <div class="col-lg-3 col-md-6 d-md-flex align-items-md-stretch" data-aos="fade-up">
            <div class="count-box">
              <i class="icofont-simple-smile"></i>
              <span data-toggle="counter-up">232</span>
              <p><strong>Happy Clients</strong> consequuntur quae</p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 d-md-flex align-items-md-stretch" data-aos="fade-up" data-aos-delay="100">
            <div class="count-box">
              <i class="icofont-document-folder"></i>
              <span data-toggle="counter-up">521</span>
              <p><strong>Projects</strong> adipisci atque cum quia aut</p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 d-md-flex align-items-md-stretch" data-aos="fade-up" data-aos-delay="200">
            <div class="count-box">
              <i class="icofont-live-support"></i>
              <span data-toggle="counter-up">1,463</span>
              <p><strong>Hours Of Support</strong> aut commodi quaerat</p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 d-md-flex align-items-md-stretch" data-aos="fade-up" data-aos-delay="300">
            <div class="count-box">
              <i class="icofont-users-alt-5"></i>
              <span data-toggle="counter-up">15</span>
              <p><strong>Hard Workers</strong> rerum asperiores dolor</p>
            </div>
          </div>

        </div>

      </div>
    </section>
    End Facts Section -->

    <!-- ======= Skills Section ======= -->
    <section id="skills" class="skills section-bg">
      <div class="container">

        <div class="section-title">
          <h2>Habilidades</h2>
          <p>Mis conocimientos y habilidades entorno al desarrollo front-end y al desarrollo back-end. </p>
          <small class="d-block text-muted" data-aos="fade-in" data-aos-delay="100">*El porcentaje de las graficas corresponden a mi desempeño en cada una</small>
        </div>

        <div class="row skills-content">

          <div class="col-lg-6" data-aos="fade-up">

            <div class="progress">
              <span class="skill">HTML <i class="val">70%</i></span>
              <div class="progress-bar-wrap">
                <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>

            <div class="progress">
              <span class="skill">CSS <i class="val">80%</i></span>
              <div class="progress-bar-wrap">
                <div class="progress-bar" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>

            <div class="progress">
              <span class="skill">JavaScript <i class="val">50%</i></span>
              <div class="progress-bar-wrap">
                <div class="progress-bar" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>

            <div class="progress">
              <span class="skill">NodeJS <i class="val">70%</i></span>
              <div class="progress-bar-wrap">
                <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>

            <div class="progress">
              <span class="skill">MongoDB <i class="val">75%</i></span>
              <div class="progress-bar-wrap">
                <div class="progress-bar" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>

          </div>

          <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">

            <div class="progress">
              <span class="skill">Bootstrap <i class="val">85%</i></span>
              <div class="progress-bar-wrap">
                <div class="progress-bar" role="progressbar" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>

            <div class="progress">
              <span class="skill">SASS <i class="val">40%</i></span>
              <div class="progress-bar-wrap">
                <div class="progress-bar" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>

            <div class="progress">
              <span class="skill">TypeScript <i class="val">80%</i></span>
              <div class="progress-bar-wrap">
                <div class="progress-bar" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>

            <div class="progress">
              <span class="skill">Angular <i class="val">85%</i></span>
              <div class="progress-bar-wrap">
                <div class="progress-bar" role="progressbar" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>

            <div class="progress">
              <span class="skill">MySQL <i class="val">60%</i></span>
              <div class="progress-bar-wrap">
                <div class="progress-bar" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>

          </div>

        </div>

      </div>
    </section><!-- End Skills Section -->

    <!-- ======= Resume Section ======= -->
    <section id="resume" class="resume">
      <div class="container">

        <div class="section-title">
          <h2>Resumen</h2>
          <p>Mi experiencia obtenida mediante estudios, cursos y trabajos realizados.</p>
        </div>

        <div class="row">

          <div class="col-lg-6" data-aos="fade-up">

            <h3 class="resume-title">Educación</h3>
            <div class="resume-item">
              <h4>Ingeniería en tecnologias de la información y comunicaciones</h4>
              <h5>2015 - 2020</h5>
              <p><em>Tecnologico de Estudios Superiores de Cuautitlán Izcalli, MX</em></p>
              <p>Concluyendo el 100% de los requerimientos para obtener el titulo de ingenierio mediante tesis.</p>
            </div>
            <div class="resume-item">
              <h4>Ténico en programación</h4>
              <h5>2012 - 2015</h5>
              <p><em>Colegio de Estudios Científicos y Tecnológicos del Estado de México, MX</em></p>
              <p>Concluyendo el 100% de los requerimientos para obtener el grado de tecnico mediante tesina.</p>
            </div>
          </div>

          <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">

            <h3 class="resume-title">Cursos</h3>
            <div class="resume-item">
              <h4>Master en JavaScript: Aprender JS, jQuery, Angular, NodeJS</h4>
              <p><em><a href="https://www.udemy.com/share/101tl4AEMbdV5RTX4H/">Udemy - Master en JavaScript</a></em></p>
            </div>
            <div class="resume-item">
              <h4>Master en CSS: Responsive, SASS, Flexbox, Grid y Bootstrap 4</h4>
              <p><em><a href="https://www.udemy.com/share/102qkKAEMbdV5RTX4H/">Udemy - Master en CSS</a></em></p>
            </div>
            <div class="resume-item">
              <h4>Angular y NodeJS en producción - Configurar un servidor VPS</h4>
              <p><em><a href="https://www.udemy.com/share/1024IoAEMbdV5RTX4H/">Udemy - Angular y NodeJS en producción</a></em></p>
            </div>
          </div>
        </div>

          <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
            <h3 class="resume-title">Experiencia Profesional</h3>
            <div class="resume-item">
              <h4>Desarrollo de Blog Profesional</h4>
              <p><em>Cuautitlán Izcalli, Estado de México, MX </em></p>
              <ul>
                <li>Implementación del framework Angular al diseño proporcionado por el equipo.</li>
                <li>Otorgar tareas al equipo para un óptimo desempeño, principalmente en UI/UX. </li>
                <li>Diseñar e implementar el esquema de la base de datos (NoSql).</li>
                <li>Implementar el back-end (NodeJs) con sus middlewares y rutas.</li>
                <li>Implementar programación en TypeScript para el panel administrativo.</li>
              </ul>
            </div>
            <div class="resume-item">
              <h4>Geolocalización</h4>
              <h5>2017 - 2017</h5>
              <p><em>Tecnologico de Estudios Superiores de Cuautitlán Izcalli, MX</em></p>
              <ul>
                <li>Diseñar UI.</li>
                <li>Diseñar e implementar un sistema de rutas mediante el uso de coordenadas.</li>
                <li>Implementar programación en JavaScript.</li>
                <li>Implementar y usar la API de Google Maps con multiples Waypoints.</li>
              </ul>
            </div>
          </div>
      </div>
    </section><!-- End Resume Section -->

    <!-- ======= Testimonials Section ======= -->
    <section id="testimonials" class="testimonials section-bg">
      <div class="container">

        <div class="section-title">
          <h2>Referencias</h2>
          <p>Mis referencias con las que he trabajado, cumpliendo expectativas y dando altos resultados satisfactorios.</p>
        </div>

        <div class="d-flex justify-content-center">

          <div class="ml-4 testimonial-item" data-aos="fade-up">
            <img src="assets/img/testimonials/rodolfo.jpg" class="testimonial-img" alt="">
            <h3>Ing. Rodolfo Vázquez Pimentel</h3>
            <h4>Desarrollador Web &amp; Freelancer</h4>
          </div>

        </div>
      </div>
    </section><!-- End Testimonials Section -->

    <!-- ======= Contact Section ======= -->
    <section id="contact" class="contact">
      <div class="container">

        <div class="section-title">
          <h2>Contacto</h2>
          <p>Si desea comunicarse conmigo, puede realizarlo de las siguientes maneras.</p>
        </div>

        <div class="row" data-aos="fade-in">

          <div class="col-lg-5 d-flex align-items-stretch">
            <div class="info">
              <div class="address">
                <i class="icofont-google-map"></i>
                <h4>Ubicación:</h4>
                <p>Cuautitlán Izcalli, Estado de México, MX CP. 54760</p>
              </div>

              <div class="email">
                <i class="icofont-envelope"></i>
                <h4>Email:</h4>
                <p><a href="mailto:david.raygosa97@gmail.com">david.raygosa97@gmail.com</a></p>
              </div>

              <div class="phone">
                <i class="icofont-phone"></i>
                <h4>Teléfono:</h4>
                <p><a href="tel:+525560926093">+52 55 6092 6093</a></p>
              </div>

              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3758.143293154873!2d-99.23855778468176!3d19.621170739707107!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d21e80e7f062e3%3A0x1d961ee178670544!2sCto.%20Bosques%20de%20Bolognia%2C%20Bosques%20del%20Lago%2C%2054766%20Cuautitl%C3%A1n%20Izcalli%2C%20M%C3%A9x.!5e0!3m2!1ses-419!2smx!4v1608150640048!5m2!1ses-419!2smx" frameborder="0" style="border:0; width: 100%; height: 290px;" allowfullscreen></iframe>
            </div>

          </div>

          <div class="col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch">

            <form #form="ngForm" (ngSubmit)="Onsubmit(form)" class="php-email-form">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="name">Nombre/Empresa</label>
                  <input type="text" name="name" class="form-control" id="name" #name_DOM="ngModel" [(ngModel)]="Name_DOM" required/>
                </div>
                <div class="form-group col-md-6">
                  <label for="name">Email</label>
                  <input type="email" class="form-control" name="email" id="email" #email_DOM="ngModel" [(ngModel)]="Email_DOM" required/>
                </div>
              </div>
              <div class="form-group">
                <label for="name">Asunto</label>
                <input type="text" class="form-control" name="subject" id="subject" #subject_DOM="ngModel" [(ngModel)]="Subject_DOM" required/>
              </div>
              <div class="form-group">
                <label for="name">Mensaje</label>
                <textarea class="form-control" name="message" rows="10" #message_DOM="ngModel" [(ngModel)]="Message_DOM" required></textarea>
              </div>
              <div class="text-center" *ngIf="sentEmail"><button [ngClass]="{'submit-disabled': !form.valid}" type="submit" [disabled]="!form.valid">Enviar Mensaje</button></div>
              <div class="mb-3" *ngIf="!sentEmail">
                <div class="d-block mx-auto spinner-border text-primary" role="status"></div>
              </div>
              <div class="mt-3 text-center" *ngIf="submitMessage.length > 0">
                <span class="text-secondary"> {{submitMessage}} </span>
              </div>
            </form>

          </div>

        </div>

      </div>
    </section><!-- End Contact Section -->

    <footer id="footer-main" class="footer-main">
      <div class="d-flex justify-content-center container text-white-50">
      <!-- ======= Footer ======= -->
          <div class="mr-3">
            &copy; Copyright <strong></strong>
          </div>
      </div>
    </footer>
  </main><!-- End #main -->
  <a href="#hero" class="back-to-top"><i class="icofont-simple-up"></i></a>